<template>
    <div>


        <div>
          <Datatable
              :items="items"
              :fields="fields"

              :items-per-page="20"
              hover
              sorter
              pagination
          >
            <template #row="{item,index}">

              <td>
                <p class="text-muted">{{index+1}}</p>

              </td>

            </template>

            <template #created_at="{item}">

              <td>
                <p class="text-muted">{{get_date(item.created_at)}}</p>

              </td>

            </template>




          </Datatable>
        </div>


    </div>

</template>

<script>
    import axios from "axios";
    // import {bus} from "../../main";

    import Datatable from "@/views/customTable/Datatable";

    export default {
        name: 'TheUsers',
        components: {
          Datatable
        },
        data() {
            return {
              fields : [
                {label: 'ردیف',key:'row', _style: 'width:10%'},
                {label: 'نام',key:'name', _style: 'width:10%'},
                {label: 'کاربر',key:'phone', _style: 'width:10%;'},
                {label: 'تاریخ',key:'created_at', _style: 'width:10%;'},
              ],

                items: [],
                collapseDuration: 0,
                status_form: 0
            }
        }, mounted() {
            this.get_news();

        }, watch: {

        },
        methods: {
          get_date(date){
            return new Date(date).toLocaleDateString('IR-fa')
          },
          get_news() {
                var self = this;
                // console.log("route id "+this.$route.params.cat_id);

                axios.get('/admin/users', {}).then(function (response) {

                    var contents = response.data;

                    // items = content_cats.orders;

                    self.items = contents.map((item, id) => {
                        return {...item, id}
                    })

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }


</script>
